import React from 'react';
import { useGetRequestSelectOptions } from "../../../../hooks/request/options/useGetRequestSelectOptions";
import { BoundSelect } from "./BoundSelect";

type BoundDataDrivenSelectProps<T> =  {
  requestUrl: string;
  queryParams?: Record<string, unknown>;
  shouldAbort?: boolean;
  name: string;
  value?: string | number | null;
  label: string;
  includeAllOption?: boolean;
  onChange: (newQuery: T) => void;
}

const BoundDataDrivenSelect = <T,>({
  requestUrl,
  queryParams,
  shouldAbort,
  name,
  value = '',
  label,
  includeAllOption,
  onChange
}: BoundDataDrivenSelectProps<T>) => {

  const { options } = useGetRequestSelectOptions({ 
    requestUrl, 
    queryParams, 
    shouldAbort,
    //includeAllOption: false 
  });

  return (<BoundSelect<T>
    options={options}
    includeAllOption={includeAllOption}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
  )
};


export { BoundDataDrivenSelect };